/**
 * @project G2G 登陆鉴权 / 登陆页
 * 
 * @author  
 * @date    2023-03-02 14:00:00
 **/ 

/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { Spin } from 'antd';
import './index.less';
import 'whatwg-fetch';

// 页尾部分
import Footer from '../../layout/Footer';
import { FooterDataSource } from '../../layout/data.source.js';

export default class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      phone: ''
    };
  }

  componentWillMount() {

  }

  componentDidMount() {
    this.setState({
      name: '接口请求数据中 ...',
    });

    /**
     * 接口请求demo
     * 
     * 开发说明：后端IP不要写在每一个文件中，统一抽离一个文件配置开发环境、测试环境、线上环境对应的服务器IP地址（写一遍即可，方便修改）
     * **/
    fetch("https://jsonplaceholder.typicode.com/users")
      .then(response => {
        /**
         * 这个response是服务器返回的可读数据流，内部存储的是二进制数据
         * .json()的作用，就是读取response这个二进制数据流，并把读取到的数据,转为JSON格式的Promise对象
         * **/ 
        return response.json();
      })
      .then(data => {
        // 这里第二个.then中拿到的data, 就是接口返回最终的数据
        setTimeout(() => {
          this.setState({
            name: data[0].name || '',
            email: data[0].email || '',
            phone: data[0].phone || ''
          });
        }, 1000); 
        // 标注：此处添加1s的延时，方便看清楚数据请求加载的过程，实际开发中不需要添加定时器和延时器（除非业务逻辑需要前端定时轮训后端接口）
        console.log('接口返回数据 =>', data);
      })
      .catch(err => {
        // 如果接口请求失败，捕获异常（切记开发时要考虑到特殊情况，增加兜底逻辑）
        console.error(err);

        this.setState({
          name: '',
          email: '',
          phone: ''
        });
      })
  };

  render() {
    const { name, email, phone } = this.state;
    return (
      <div
        className="templates-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      >
        {
          email === '' ? (
            <div className="login-page">
              <Spin tip={name} size="large"></Spin>
            </div>
          ) : (
            <div className="login-page">
              <p>用户名: {name}</p>
              <p>邮箱: {email}</p>
              <p>电话: {phone}</p>
            </div>
          )
        }
        <Footer 
          id="Footer"
          key="Footer"
          dataSource={FooterDataSource} 
        />
      </div>
    );
  }
}
